import React from 'react';
import {twMerge} from 'tailwind-merge';
import {cva} from 'class-variance-authority';
import clsx from 'clsx';
import {inputSizes} from 'utils/uiSizes';
import {getFormFieldVariants, getFormFieldDefaultVariants} from 'utils/formVariants';

const baseClassName = clsx(
	'block px-3 rounded-md text-gray-900 dark:text-gray-100 shadow-sm border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 ring-0 transition-colors',
	'placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2',
	'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-blue-500 focus-visible:ring-opacity-20 focus-visible:border-opacity-50',
);

const inputVariants = cva(baseClassName, {
	variants: {
		...getFormFieldVariants(),
		size: {
			xs: inputSizes.xs,
			sm: inputSizes.sm,
			md: inputSizes.md,
			lg: inputSizes.lg,
		},
	},
	defaultVariants: {
		...getFormFieldDefaultVariants(),
		size: 'md',
	},
});

const Input = React.forwardRef(
	(
		{error, ignorePasswordManagers, variant, modified, size, className, ...props},
		ref,
	) => {
		return (
			<input
				ref={ref}
				{...props}
				{...(ignorePasswordManagers && {
					'data-1p-ignore': true,
					'data-lpignore': true,
					'data-protonpass-ignore': true,
				})}
				className={twMerge(inputVariants({variant, modified, size}), className)}
			/>
		);
	},
);

Input.displayName = 'Input';

export default Input;
